import { render } from "./SourcesView.vue?vue&type=template&id=f17a9c3a"
import script from "./SourcesView.vue?vue&type=script&lang=js"
export * from "./SourcesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__